import $ from 'jquery'

import Hub from 'base/hub'
import Event from 'base/event'
import store from 'base/store'

window._sift = window._sift || []

function loadSift() {
  if (!store.getState().appConfig.isProductionLike) return

  const protocol = document.location.protocol === 'https:' ? 'https://' : 'http://'
  return $.getScript(`${protocol}cdn.siftscience.com/s.js`)
}

function pushCurrentUser() {
  const state = store.getState()

  const currentUser = state.session.user
  const sid = state.session.visitor.session_id

  currentUser && window._sift.push(['_setUserId', currentUser.guid])

  return window._sift.push(['_setSessionId', sid])
}

function setupSift() {
  window._sift = window._sift || []

  window._sift.push(['_setAccount', store.getState().appConfig.siftApiKey])
  pushCurrentUser()
  window._sift.push(['_trackPageview'])

  Hub.sub(Event.User.SIGN_IN, pushCurrentUser)

  return loadSift()
}

export default setupSift
